import { AgentTunnelSession } from "@/model/data/remoteLink/AgentTunnelSession";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class StartAgentTunnelSessionResData extends ApiGenericResponse {
    newSessions: Array<AgentTunnelSession>;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.NewSessions) {
            this.newSessions = new Array<AgentTunnelSession>();
            obj.NewSessions.forEach((newSession) => {
                let s = new AgentTunnelSession();
                s.parse(newSession);
                this.newSessions.push(s);
            });
        }
    }
}
